import { render, staticRenderFns } from "./overdue-penalty.vue?vue&type=template&id=53c27650&scoped=true&"
import script from "./overdue-penalty.vue?vue&type=script&lang=js&"
export * from "./overdue-penalty.vue?vue&type=script&lang=js&"
import style0 from "./overdue-penalty.vue?vue&type=style&index=0&id=53c27650&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c27650",
  null
  
)

export default component.exports